import React, { useEffect } from "react";
const Timmer = (props) => {
    const [timer, setTimer] = React.useState({
        min: props.min,
        sec: props.sec,
    });
    useEffect(() => {
        if (props === null || props === void 0 ? void 0 : props.timerState) {
            setTimer({
                min: props.min,
                sec: props.sec,
            });
        }
    }, [props === null || props === void 0 ? void 0 : props.timerState]);
    React.useEffect(() => {
        let intervalId = setInterval(function () {
            countDown(timer.min, timer.sec, setTimer);
        }, 1000);
        if (timer.min === 0 && timer.sec === 0) {
            clearInterval(intervalId);
            props === null || props === void 0 ? void 0 : props.onTimerClose(true);
        }
        return () => {
            clearInterval(intervalId);
        };
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "timer ps-1" },
            React.createElement("span", null,
                "0",
                timer.min),
            React.createElement("span", null, ":"),
            React.createElement("span", null, timer.sec > 9 ? timer.sec : "0" + timer.sec))));
};
export function countDown(min, sec, cb) {
    if (sec === 0 && min !== 0) {
        return cb({ min: min - 1, sec: 59 });
    }
    else if (sec > 0) {
        if (sec > 10) {
            return cb({ min: min, sec: sec - 1 });
        }
        else {
            return cb({ min: min, sec: sec - 1 });
        }
    }
}
export default Timmer;
